var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSourceDirect = function SvgSourceDirect(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "#8290A2",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75016 9.91683C3.75016 9.45659 4.12326 9.0835 4.5835 9.0835H5.41683C5.87707 9.0835 6.25016 9.45659 6.25016 9.91683C6.25016 10.3771 5.87707 10.7502 5.41683 10.7502H4.5835C4.12326 10.7502 3.75016 10.3771 3.75016 9.91683Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 9.0835C7.87326 9.0835 7.50016 9.45659 7.50016 9.91683C7.50016 10.3771 7.87326 10.7502 8.3335 10.7502H10.8335C11.2937 10.7502 11.6668 10.3771 11.6668 9.91683C11.6668 9.45659 11.2937 9.0835 10.8335 9.0835H8.3335Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91683 0.333496C1.76624 0.333496 0.833496 1.26624 0.833496 2.41683V11.5835C0.833496 12.7341 1.76624 13.6668 2.91683 13.6668H17.0835C18.2341 13.6668 19.1668 12.7341 19.1668 11.5835V2.41683C19.1668 1.26624 18.2341 0.333496 17.0835 0.333496H2.91683ZM2.50016 2.41683C2.50016 2.18671 2.68671 2.00016 2.91683 2.00016H17.0835C17.3136 2.00016 17.5002 2.18671 17.5002 2.41683V3.66683H2.50016V2.41683ZM2.50016 6.16683V11.5835C2.50016 11.8136 2.68671 12.0002 2.91683 12.0002H17.0835C17.3136 12.0002 17.5002 11.8136 17.5002 11.5835V6.16683H2.50016Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSourceDirect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source-direct.4427e436.svg";
export { ForwardRef as ReactComponent };